<template>
  <div class="bookings">
    <page-header title="Create New Consolidation" :back="{ path: '/operations/consolidation/' }"
      breadcrumb="Dashboard > Operations > Load Consolidation" />

    <h2 class="text-lg font-semibold my-12">Select Shipments</h2>

    <div class="flex items-center justify-between" style="height: 40px">
      <div class="h-full flex items-center">
        <el-dropdown>
          <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
            style="width: 40px; height: 40px; background-color: #f7fafd">
            <sort-icon />
          </button>
          <el-dropdown-menu slot="dropdown" placement="right-end">
            <el-dropdown-item disabled>SORT BY</el-dropdown-item>

            <el-dropdown-item>
              <button @click="sortOrder = 'ASC'" class="flex items-center">
                <span class="ml-2">ASC</span>
              </button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button @click="sortOrder = 'DESC'" class="flex items-center">
                <span class="ml-2">DESC</span>
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="flex items-center mr-12">
          <el-select v-model="selectedShippingServiceId" placeholder="Select service route" @change="getAllBookings"
            style="margin: 0">
            <el-option label="all" :value="null" />
            <el-option v-for="shippingservice in locationBasedRoutes" :key="shippingservice.id"
              :label="shippingservice.routeName" :value="shippingservice.id">
            </el-option>
          </el-select>
        </div>

        <div hidden class="date-picker flex items-center justify-center">
          <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />

          <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
        </div>
      </div>

      <el-dropdown class="h-full" v-if="payload && payload.shipments && payload.shipments.length">
        <button class="table-assign bg-charcoal text-white h-full rounded flex items-center px-3">
          <span class="border-r border-white mr-3 pr-2">Assign to Fleet</span>

          <arrow-down-filled />
        </button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <button @click="
              showConsolidationDialog = true;
            newBooking = false;
            ">
              Assign to Fleet
            </button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button @click="
              newBooking = true;
            createConsolidation({ status: 'on-hold' });
            ">
              Create a New Booking
            </button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button @click="
              newBooking = false;
            createConsolidation({ status: 'on-hold' });
            ">
              Keep On-Hold
            </button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th class="width-xs">
              <base-checkbox v-model="selectAll" />
            </th>
            <th class="shipping-ref-col width-sm">Shipping Id + Date</th>
            <th>Shipping Service + Est. Delivery Date</th>
            <th class="text-center">Gross Weight (kg)</th>
            <th>Special Handling</th>
            <th>Ship from<br>(Origin)</th>
            <th>Ship to<br>(Destination)</th>
            <th>Sender</th>
            <th>Receiver</th>
            <th class="width-md d-flex align-items-center relative">Load Status</th>
            <th class="relative width-xs" tabindex="-1" @blur="isTableFilter = false">
              <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51" />
                  </g>
                </svg></span>
              <div v-if="isTableFilter">
                <table-filter @update-table="updateTableData($event)" />
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="unassignedBookings && unassignedBookings.length && !isFetchingBookings">
          <tr v-for="(booking, index) in filteredBookings" :key="booking.shipping.id" class="cursor-pointer">
            <td>
              <base-checkbox :value="booking.shipping.id" v-model="payload.shipments" />

              <label :for="`booking${index}`" class="check-label"></label>
            </td>

            <td>
              <span>{{
                booking.shipping.shippingReference ? booking.shipping.shippingReference : "N/A"
                }}</span><span>MuleEx</span>
            </td>

            <td>
              {{
                booking.shipping.shippingservice
                  ? booking.shipping.shippingservice.orgName
                  : "N/A"
              }} <br>
              <!-- <span>{{
                booking.shipping.sourcePickupTime
                  ? booking.shipping.sourcePickupTime.split(",")[0]
                  : "N/A"
              }}</span>
              <span>{{
                booking.shipping.sourcePickupTime
                  ? booking.shipping.sourcePickupTime.split(",")[1]
                  : "N/A"
              }}</span> -->
            </td>

            <td class="text-center">
              {{ returnItemsWeights(booking.shipping.packagees) }}
            </td>

            <td>
              {{ returnHandlingRequirements(booking.shipping.packagees) }}
            </td>

            <td>
              <span v-if="booking.shipping.shipperlocation">
                <span>{{
                  formatAddress(booking.shipping.shipperlocation.address)
                }}
                </span><span>Nigeria.</span>
              </span>
              <span v-else>N/A</span>
            </td>

            <td>
              <span v-if="booking.shipping.consigneelocation">
                <span>
                  {{
                    formatAddress(booking.shipping.consigneelocation.address)
                  }}
                </span>
                <span>Nigeria.</span>
              </span>
              <span v-else>N/A</span>
            </td>

            <td>
              <span v-if="booking.shipping.shipperlocation">
                <span>
                  {{
                    booking.shipping.shipperlocation.contactName
                  }}<br>
                  {{ booking.shipping.shipperlocation.mobile }}
                </span>
              </span>
              <span v-else>N/A</span>
            </td>

            <td>
              <span v-if="booking.shipping.consigneelocation">
                <span>
                  {{
                    booking.shipping.consigneelocation.contactName
                  }}<br>
                  {{ booking.shipping.consigneelocation.mobile }}
                </span>
              </span>
              <span v-else>N/A</span>
            </td>

            <td>
              <span
                v-if="booking.terminalStatus == 'active' || booking.terminalStatus == 'pending' || booking.terminalStatus == 'received'"
                class="booking-status pending">{{ capitalize(booking.terminalStatus) }}</span>
              <span v-else class="booking-status cancelled">Cancelled</span>
            </td>
            <td class="cursor-pointer relative" tabindex="-1">
              <el-dropdown>
                <button>
                  <vertical-ellipsis />
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item disabled>ACTIONS</el-dropdown-item>

                  <el-dropdown-item>
                    <button class="flex items-center" @click="
                      showEditBookingModal = true;
                    selectedBooking = booking;
                    ">
                      <decline-icon />
                      <span class="ml-2">Modify</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button class="flex items-center" @click="
                      showCancelModal = true;
                    selectedBooking = booking;
                    ">
                      <cancel-icon />
                      <span class="ml-2">Cancel</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button class="flex items-center" @click="routeBookingSumary(booking)">
                      <package-icon />
                      <span class="ml-2">Print</span>
                    </button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="py-5 bg-white w-100" v-if="isFetchingBookings">
      <loader />
    </div>

    <div v-if="!filteredBookings && !filteredBookings.length && !isFetchingBookings"
      class="bg-white w-100 flex justify-center flex-col items-center p-5">
      <empty-table-icon />
      <p class="font-semibold pt-3 pb-5">No Items found!</p>
    </div>

    <div class="mt-3">
      <pagination-control :total="totalBookings" :pageNumber="pageNumber" @pageSize="pageSize = $event"
        @pageNumber="pageNumber = $event" />
    </div>

    <!--========= modals =========-->
    <el-dialog :visible.sync="showConsolidationDialog" width="60%">
      <div class="flex items-start justify-between mb-4">
        <div>
          <h2 class="text-2xl font-semibold">Consolidation ID#</h2>
          <div>457906-04</div>
        </div>

        <div>
          <h3 class="text-lg font-semibold">Est. Consolidated cap. (Tonnes)</h3>
          <div>{{ fleetDetails.carriageCapacity }} Tons</div>
        </div>
      </div>
      <!-- {{ filterUndispatchedFleet  }} -->
      <div class="flex flex-wrap justify-between">
        <div class="flex flex-wrap w-full justify-between">
          <div class="places_wrapper mb-4" style="border: 1px solid #dae8f6; height: 200px">
            <div class="pl-4 flex items-center font-semibold" style="background: #ecf3fb; height: 60px">
              Origin
            </div>

            <div class="px-4 mt-4">
              {{
                currentLocation
                  ? currentLocation.location.locationName
                  : "No Location Selected"
              }},
              <br />
              {{ currentLocation ? currentLocation.location.address : "" }}
            </div>
          </div>

          <div class="mb-4 places_wrapper" style="border: 1px solid #dae8f6; height: 200px">
            <div class="pl-4 flex items-center font-semibold" style="background: #cef1e8; height: 60px">
              Destination
            </div>

            <div class="px-4 mt-4">
              <label class="mb-1">Destination</label>

              <el-select v-model="payload.destination" placeholder="Select Destinations">
                <el-option v-for="location in locations" :key="location.id" :label="location.locationName"
                  :value="location.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="w-full flex flex-wrap justify-between">
          <div class="w-full md:w-6/12">
            <label class="mb-1">Vehicle Type/ Carrying Capacity</label>
            <div class="w-full flex items-center gap-3">
              <el-select v-model="payload.vehicleType" placeholder="Select vehicle type">
                <el-option v-for="vehicleType in fleetForConsolidation" :key="vehicleType.type"
                  :label="vehicleType.type" :value="vehicleType.type">
                </el-option>
              </el-select>

              <el-select v-model="fleetCapacity" placeholder="Select fleet">
                <el-option v-for="fleet in filterFleetByType" :key="fleet.capacity" :label="fleet.capacity"
                  :value="fleet.capacity">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="w-full md:w-5/12">
            <label class="mb-1">Plate Number</label>
            <el-select v-model="payload.fleetId" placeholder="Select fleet">
              <el-option v-for="fleet in filterFleetByTypeTonnage" :key="fleet.vehicleNumber"
                :label="fleet.vehicleNumber" :value="fleet.id">
              </el-option>
            </el-select>
            <p class="driver_details">
              Driver: {{ driverName }}
            </p>
          </div>
        </div>

        <div class="mt-5 w-full md:w-6/12">
          <label>Upload Documents</label>
          <div :style="{
            'background-color': '#FBFCFE',
            border: '1px solid #DAE8F6',
          }" class="pt-2 px-3 rounded-lg overflow-hidden flex justify-between pb-2 w-full">
            <div :style="{ color: '#B7BDCD', fontSize: '16px' }" class="mt-1 w-9/12">
              <p v-if="!isUploadingDoc && !docUploaded">Upload File</p>
              <div v-if="isUploadingDoc" class="d-flex justify-content-center py-2 -mt-2">
                <saving-loader :icon-color="'#0253B3'" />
              </div>
            </div>

            <button @click="triggerUpload = true" :style="{
              'background-color': '#CBE0F6',
              height: '32px',
              width: '91px',
            }" class="rounded-lg w-3/12">
              Upload
            </button>
          </div>

          <div class="mt-3">
            <div class="image_list" v-for="url in payload.documentUrl" :key="url">{{ url.substring(url.length - 20)
            }}<button @click="removeImageUrl(url)">&#x2715;</button>
            </div>
          </div>

          <document-upload hidden ref="documentUploader" @input="handleDocUpload($event)"
            @closeTrigger="triggerUpload = false" @remove-image="removeImage" :docurl="docurl"
            :triggerUpload="triggerUpload" :isUploadingImage="isUploadingDoc" />
        </div>

        <div class="mt-5">
          <div class="flex flex-no-wrap justify-between gap-2">
            <p>Truck Capacity {{ " " }} </p>
            <p v-if="fleetDetails != 'N.A'">
              {{ calculateCapacity }}/{{ Number(fleetDetails.carriageCapacity) }} Tons
            </p>
          </div>
          <div class="flex flex-row-reverse h-[17px] mt-4">
            <div :style="{ 'background-color': '#D5F2EA' }" class="w-100 relative z-20 h-6 rounded-r-lg"
              v-if="(calculateCapacity / Number(fleetDetails.carriageCapacity)) * 100 < 100"></div>
            <div :style="{
              'background-color': '#00C48C',
              width:
                fleetDetails != 'N.A'
                  ? (calculateCapacity / Number(fleetDetails.carriageCapacity)) *
                  100 +
                  '%'
                  : '0%',
            }" class="h-6 relative z-10 rounded-l-lg"></div>
          </div>
        </div>
      </div>

      <div class="flex justify-between mt-5" style="height: 40px">
        <button class="h-full bg-charcoal text-white rounded font-semibold" style="width: 120px"
          @click="createConsolidation('consolidation-completed')">
          Complete
        </button>

        <div class="h-full">
          <button class="h-full font-semibold" style="width: 120px" @click="showConsolidationDialog = false">
            Cancel
          </button>

          <primary-button class="h-full bg-primary-yellow rounded font-semibold" buttonText="Save" style="width: 120px"
            :loading="isLoading" :disabled="!canSave" @click="createConsolidation('in-progress')" />

        </div>
      </div>
    </el-dialog>
    <edit-booking-modal :show-modal="showEditBookingModal" :booking="selectedBooking"
      @close-modal="showEditBookingModal = false" />
    <confirm-cancel-modal :show-modal="showCancelModal" @booking-subaction-completed="actionCompleted"
      :booking="selectedBooking" @close-modal="showCancelModal = false" @show-cancel-modal="
        showCancelModal = false;
      showFinCancelModal = true;
      " />
    <cancel-modal @booking-subaction-completed="actionCompleted" :show-modal="showFinCancelModal"
      @close-modal="showFinCancelModal = false" :booking="selectedBooking" />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";
import TableFilter from "./TableFilter";
import EditBookingModal from "@/components/3pl/Operations/Bookings/Modals/EditBookingModal";
import ConfirmCancelModal from "@/components/3pl/Operations/Bookings/Modals/ConfirmCancelModal";
import CancelModal from "@/components/3pl/Operations/Bookings/Modals/CancelModal";
import moment from "moment";
import SavingLoader from "@/components/UI/ButtonSavingLoader";

export default {
  components: {
    PageHeader,
    PaginationControl,
    TableFilter,
    ConfirmCancelModal,
    EditBookingModal,
    CancelModal,
    SavingLoader,
  },
  data() {
    return {
      date: "",
      showCancelModal: false,
      showEditBookingModal: false,
      selectedBooking: {},
      isTableFilter: false,
      showFinCancelModal: false,
      removedTableData: [
        "routing",
        "handOff",
        "receiveFrom",
        "deliverTo",
        "distance",
        "weight",
        "income",
        "fleet",
        "driver",
      ],
      fleetCapacity: null,
      payload: {
        orgId: "",
        userId: "",
        origin: "",
        destination: "",
        vehicleType: "",
        plateNumber: "",
        driverName: "",
        destinationName: "",
        fleetId: "",
        documentUrl: [],
        consignees: [],
        status: "on-hold" // only needed for on hold
      },
      bookings: [],
      vehicleType: "",
      vehicleTypes: ["Motorcycle", "Van", "Truck"],
      fleets: [],
      shippingServices: [],
      consolidationRequest: {
        shippingId: [],
        fleetId: null,
      },
      selectedShippingServiceId: null,
      isLoading: false,
      isFetchingBookings: false,
      selectAll: false,
      selectedShippingIds: [],
      selectedFleetId: null,
      query: "",
      docurl: "",
      actionRowId: null,
      isUploadingDoc: false,
      states: [],
      state: "",
      showConsolidationDialog: false,
      location: { address: "" },
      startDate: null,
      endDate: null,
      newBooking: false,
      sortOrder: "ASC",
      pageNumber: 1,
      pageSize: 10,
      totalBookings: 1,
      sortColumn: "",
      currentTab: "pending",
      locations: [],
      triggerUpload: false,
      fileName: "",
      docUploaded: false,
      fleetForConsolidation: [],
      selectedShipmentDetails: [],
      lastEndpointLoading: false
    };
  },
  computed: {
    driverName() {
      return `${this.filterFleetByTypeTonnage[0]?.user?.firstname || ""} ${this.filterFleetByTypeTonnage[0]?.user?.lastname || ""}`;
    },
    canSave() {
      return this.payload.fleetId && this.payload.destination
    },
    filterFleetByType() {
      const typeFleets = this.fleetForConsolidation.find(item => item.type === this.payload.vehicleType)?.fleets || [];
      return typeFleets;
    },
    filterFleetByTypeTonnage() {
      const vehicleFleets = this.filterFleetByType.filter(item => item.capacity === this.fleetCapacity) || [];
      return vehicleFleets;
    },
    filterUndispatchedFleet() {
      return this.fleets.filter((f) => f.status != "dispatched");
    },
    unassignedBookings() {
      return this.bookings.filter((booking) => {
        return booking.terminalStatus == "active" || booking.terminalStatus == 'pending' || booking.terminalStatus == 'received' && !booking.shipping.consolidationId;
      });
    },
    filteredBookings() {
      return this.unassignedBookings;
    },
    calculateCapacity() {
      let shipmentsBookings = [];

      if (this.payload?.shipments?.length) {
        this.payload.shipments.forEach((x) => {
          let found = this.selectedShipmentDetails.find((y) => y.id == x);
          shipmentsBookings.push(found);
        });

        let initialWeight = 0;
        let allPackages = shipmentsBookings.map((x) => x?.packages);
        if (allPackages.length) {
          let weights = [];
          allPackages.forEach((x) => {
            if (x != undefined) {
              weights.push(...x.map((y) => Number(y.estimatedWeight) * Number(y.quantity)));
            }
          });

          let totalWeightKg = weights.reduce(
            (pre, next) => pre + next,
            initialWeight
          );
          let totalWeightTons = totalWeightKg * 0.001;

          return totalWeightTons;
        } else {
          return 0;
        }

      } else {
        return 0;
      }
    },
    organizationId() {
      return this.$store.state.authentication.organizationId;
    },
    userId() {
      return this.$store.state.authentication.userId;
    },
    currentLocation() {
      return this.$store.getters.currentLocation;
    },
    fleetDetails() {
      if (!this.payload.fleetId) return "N.A";
      return this.fleets.find((fleet) => fleet.id === this.payload.fleetId);
    },
    destinationName() {
      let location = this.locations.find(
        (x) => x.id == this.payload.destination
      );
      console.log("location selected", location);
      return location?.locationName + ", " + location?.state;
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    },
    locationBasedRoutes() {
      return this.shippingServices.filter(x => x.takeOffId == this.locationId)
    }
  },
  watch: {
    isTableFilter() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 500;
    },
    selectedShippingServiceId(val) {
      if (val != null) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingserviceId: this.selectedShippingServiceId,
          sortOrder: this.sortOrder,
          startDate:
            this.startDate?.length > 0
              ? moment(this.startDate).format("YYYY-MM-DD")
              : "",
          endDate:
            this.endDate?.length > 0
              ? moment(this.endDate).format("YYYY-MM-DD")
              : "",
          searchTerm: this.queryString,
          pageSize: this.pageSize,
          sortColumn: this.sortColumn
        });
      } else {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingserviceId: this.selectedShippingServiceId,
          sortOrder: this.sortOrder,
          startDate:
            this.startDate?.length > 0
              ? moment(this.startDate).format("YYYY-MM-DD")
              : "",
          endDate:
            this.endDate?.length > 0
              ? moment(this.endDate).format("YYYY-MM-DD")
              : "",
          searchTerm: this.queryString,
          pageSize: this.pageSize,
          sortColumn: this.sortColumn
        });
      }
    },
    sortOrder() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingserviceId: this.selectedShippingServiceId,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        searchTerm: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    },
    queryString() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingserviceId: this.selectedShippingServiceId,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        searchTerm: this.queryString,
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    },
    locationId() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingserviceId: this.selectedShippingServiceId,
        sortOrder: this.sortOrder,
        startDate:
          this.startDate != null
            ? moment(this.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.endDate != null ? moment(this.endDate).format("YYYY-MM-DD") : "",
        pageSize: this.pageSize,
        sortColumn: this.sortColumn,
      });
    },
    startDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingserviceId: this.selectedShippingServiceId,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }
      if (!this.startDate && !this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingserviceId: this.selectedShippingServiceId,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },
    endDate() {
      if (this.startDate && this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingserviceId: this.selectedShippingServiceId,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
        });
      }
      if (!this.startDate && !this.endDate) {
        this.getBookings({
          status: this.currentTab,
          terminalId: this.locationId,
          shippingserviceId: this.selectedShippingServiceId,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
      }
    },
    pageSize() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingserviceId: this.selectedShippingServiceId,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },
    pageNumber() {
      this.getBookings({
        status: this.currentTab,
        terminalId: this.locationId,
        shippingserviceId: this.selectedShippingServiceId,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...(this.startDate && {
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
        ...(this.endDate && {
          endDate: moment(this.startDate).format("YYYY-MM-DD"),
        }),
      });
    },
    selectAll(val) {
      if (val) {
        this.filteredBookings.forEach((booking) => {
          this.payload.shipments.push(booking.shipping.id);
        });
      } else {
        this.payload.shipments = [];
      }
    },
  },
  mounted() {
    this.getBookings({ status: this.currentTab, terminalId: this.locationId, shippingserviceId: this.selectedShippingServiceId });
    this.getAllLocations();
    this.getAllFleets();
    this.getAllFleetsForConsolidation();
    this.getAllStates();
    this.getAllShippingServices();

    if (this.$route.params.preSelect) {
      this.payload.shipments = this.$route.params?.preSelect;
      this.selectedShipmentDetails = this.$route.params?.preselectDetails;
      this.showConsolidationDialog = true
    }
  },
  methods: {
    routeBookingSumary(val) {
      this.$router.push({ name: "BookingSummary", params: { id: val.id } });
    },
    getAllBookings() {
      this.getBookings({ status: this.currentTab, terminalId: this.locationId, shippingserviceId: this.selectedShippingServiceId });
    },
    actionCompleted() {
      this.showCancelModal = false;
      this.getBookings({ status: this.currentTab, terminalId: this.locationId, shippingserviceId: this.selectedShippingServiceId });
    },
    getDestinationName() {
      let location = this.locations.find(
        (x) => x.id == this.payload.destination
      );
      return location;
    },
    async createConsolidation(status) {
      this.isLoading = true;
      if (this.newBooking) {
        this.generateToast(
          "Creating Consolidation ID for New Booking. Please wait...",
          "success"
        );
      }

      if (!this.canSave) return;

      try {
        this.payload.orgId = this.organizationId;
        this.payload.userId = this.userId;
        this.payload.driverName = this.filterFleetByTypeTonnage[0]?.user?.firstname + " " + this.filterFleetByTypeTonnage[0]?.user?.lastname || "N.A";
        this.payload.origin = this.$store.getters.currentLocationId;
        this.payload.originName = `${this.currentLocation?.location?.locationName}, ${this.currentLocation?.location?.address}`;
        this.payload.destinationName = this.getDestinationName()?.address + ", " + this.getDestinationName()?.state || "N.A";
        this.payload.destination = this.getDestinationName()?.id;
        this.payload.consignees = this.payload?.shipments;

        const { shipments, plateNumber, ...rest } = this.payload


        console.log(this.fleetDetails, shipments, plateNumber, "tonnage", this.filterFleetByTypeTonnage, {
          ...rest,
          status: status
        })


        const response = await this.$_createConsolidationNew({
          ...rest,
          status: status
        });
        this.isLoading = false;
        this.generateToast("Consolidation Created", "success");
        if (this.newBooking) {
          this.$store.dispatch("setShipConsolidationID", response.data.data.id);
          this.$router.push(
            `/operations/booking?consolidationId=${response.data.data.id}`
          );
        } else {
          this.$router.go(-1);
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllLocations() {
      try {
        const response = await this.$_getAllLocations();

        this.log(response);
        this.locations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    removeImageUrl(val) {
      this.payload.documentUrl = this.payload.documentUrl.filter(url => url != val)
    },
    async handleDocUpload(image) {
      this.isUploadingDoc = true;
      this.triggerUpload = false;
      this.fileName = image.name;
      this.docUploaded = false;

      try {
        let response = await this.updateDocument(image);
        this.docurl = response;
        this.payload.documentUrl.push(response);
        this.isUploadingDoc = false;
        this.docUploaded = true;
        this.generateToast("Document uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingDoc = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
    getCurrentLoadCap(fleet) {
      let calc = (fleet.currentLoadCapacity / fleet.carriageCapacity) * 100;
      let currentLoadCapacity = Number.parseFloat(fleet.currentLoadCapacity);
      return `${calc.toFixed()}% (${currentLoadCapacity.toFixed(2)})`;
    },
    getFleetCalculation(fleet) {
      let calc = (fleet.currentLoadCapacity / fleet.carriageCapacity) * 100;
      let currentLoadCapacity = Number.parseFloat(fleet.currentLoadCapacity);
      return `${calc.toFixed()}% (${currentLoadCapacity.toFixed(2)})`;
    },
    async getBookings(data) {
      this.isFetchingBookings = true;
      try {
        this.loading = true;
        const { data: response } = await this.$_getBookingsByTerminal(this.locationId, data);
        this.bookings = response.data.terminalShippings;
        this.totalBookings = response.data.totalCount;
        this.isFetchingBookings = false;
        console.log(this.bookings);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getAllFleets() {
      try {
        const response = await this.$_getAllFleets();

        if (this.locationId) {
          this.fleets = response.data.data.fleet.filter(
            (x) => x.terminals == this.locationId || x.allRoute
          );
        } else {
          this.fleets = response.data.data.fleet;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllFleetsForConsolidation() {
      try {
        const response = await this.$_getAllFleetsForConsolidation();
        console.log(response?.data?.data, "all fleets for consolidation");
        this.fleetForConsolidation = response?.data?.data
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllShippingServices() {
      this.lastEndpointLoading = true
      try {
        const response = await this.$_getShippingServices();

        this.shippingServices = response.data.data.shippingServices;
        // this.selectedShippingServiceId = this.shippingServices[0].id
      } catch (error) {
        this.handleError(error);
      } finally {
        this.lastEndpointLoading = false
      }
    },
    toggleAssign(isChecked, id) {
      if (isChecked) {
        this.assignToFleet(id);
      } else {
        this.unassignFromFleet(id);
      }
    },
    async unassignFromFleet(shippingId) {
      const payload = {
        shippingId: shippingId,
        fleetId: this.payload.fleetId,
      };
      this.generateToast("Unassigning from fleet", "success");
      try {
        await this.$_unassignFromFleet(payload);

        this.generateToast("Successfully removed from fleet!", "success");
        this.getAllBookings();
      } catch (error) {
        this.handleError(error);
      }
    },
    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);
      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }
      this.isTableFilter = false;
      this.scrollLeft();
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 10000;
    },
    returnPackageDescription(packageItems) {
      const packageDescriptions = [];
      packageItems.forEach((item) => {
        packageDescriptions.push(item.description);
      });
      return packageDescriptions.join(", ");
    },
    returnItemsWeights(packageItems) {
      let packageWeights = 0;
      packageItems.forEach((item) => {
        if (item.estimatedWeight) {
          packageWeights += item.estimatedWeight;
        }
      });

      return packageWeights ? packageWeights : "N.A";
    },
    returnItemsVolWeights(packageItems) {
      let volWeight = 0;
      packageItems.forEach((item) => {
        volWeight = item?.length * item?.height * item?.width;
      });
      return volWeight ? volWeight : "N.A";
    },
    returnHandlingRequirements(packageItems) {
      const handlingRequirements = [];
      packageItems.forEach((item) => {
        const itemHandlingRequirements = item.specialHandling
          ? item.specialHandling.join(",")
          : "";
        handlingRequirements.push(itemHandlingRequirements);
      });
      return handlingRequirements.join(", ");
    },
    handleShipmentSelection(event, id) {
      if (event) {
        this.payload.shipments.push(id);
      } else {
        this.payload.shipments = this.payload.shipments.filter(
          (shipment) => shipment !== id
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.driver_details {
  @apply py-1 px-2 bg-primary-blue/5 w-full text-center
}

.image_list {
  @apply flex items-center justify-between w-full border border-gray-400/40 bg-primary-blue/5 px-2 py-2 mt-2
}

.places_wrapper {
  @apply w-full lg:w-[48%]
}

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.custom-table {
  margin: 0;
}

.booking-categories {
  display: flex;
}

.booking-category {
  color: #383f51;
  opacity: 0.7;
  display: flex;
  align-items: center;
  margin-right: 1rem;

  &.active {
    font-weight: 500;
    opacity: 1;

    .booking-category-amount {
      background: #10233e;
    }
  }

  .booking-category-amount {
    background: #8a97a5;
    border-radius: 10px;
    color: #ffffff;
    margin-left: 1rem;
    padding: 0.25rem 0.75rem;
  }
}

.table-header {
  justify-content: space-between;
}

.booking-categories {
  display: flex;
  align-items: center;
  margin: 2rem 0 4rem 0;
}

th {
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

th {
  padding: 0.75rem;
  min-width: 10rem;
}

.width-md {
  min-width: 5rem;
}

.width-sm {
  min-width: 8rem;
}

.width-xs {
  min-width: 3rem !important;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }

  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.shipping-option-col {
  width: 16%;
}

.shipping-ref-col {
  width: 13%;
}

.booking-status {
  border-radius: 8px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;

  &.cancelled {
    background: #fae5e7;
    color: #d72638 !important;
  }

  &.pending {
    background: #ebfffa;
    color: #09b78a;
  }
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}

.financial-summary {
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 5px;

  .header {
    padding: 0.5rem 2rem;
  }

  width: 25rem;
}

.total-income {
  padding: 1rem 2rem;
}

.gross-income {
  background: var(--primaryblue);
  color: #ffffff;
  padding: 1rem 2rem;
}

.filter {
  background: #f7fafd;
  border-radius: 5px;
  padding: 0.75rem 1rem;
}

.card {
  padding: 2rem 2rem;
}

.input {
  margin-bottom: 1.5rem;
}

.label {
  color: #383f51;
  font-size: 0.9rem;
  font-weight: 600;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 0;
  right: 2rem;
  padding: 0.75rem;
  z-index: 9999;
  font-size: 0.9rem;
  width: 15rem;
  background: #ffffff;
  /* Stroke */
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}

.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
  border: 1px solid #dae8f6;
  border-radius: 5px;
  height: 40px;
}

.table-sort {
  background: #f7fafd;
  /* Cards/Shadow-Small */
  box-shadow: 0px 1px 2px rgba(45, 49, 66, 0.06), 0px 1px 3px rgba(8, 7, 8, 0.1);
  border-radius: 5px;
}

.table-date-filter {
  width: 207px;
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  border-radius: 4px;
}
</style>
